module.exports = __webpack_public_path__ + "static/media/baumann.placeholder.b48639f7.jpg";